import { render, staticRenderFns } from "./SafetyFreeTextReport.vue?vue&type=template&id=4e19183e&scoped=true"
import script from "./SafetyFreeTextReport.vue?vue&type=script&lang=ts"
export * from "./SafetyFreeTextReport.vue?vue&type=script&lang=ts"
import style0 from "./SafetyFreeTextReport.vue?vue&type=style&index=0&id=4e19183e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e19183e",
  null
  
)

export default component.exports